var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../../elements/Basic");

var _Touchable = _interopRequireDefault(require("../../Basic/Touchable"));

var _PropsHelper = require("../../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Betting/Voting/TipModule.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var TipModule = function (_React$Component) {
  (0, _inherits2.default)(TipModule, _React$Component);

  var _super = _createSuper(TipModule);

  function TipModule() {
    (0, _classCallCheck2.default)(this, TipModule);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(TipModule, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          bettingLinkText = _this$props.bettingLinkText,
          betting = _this$props.betting,
          fallbackLink = _this$props.fallbackLink,
          onPress = _this$props.onPress,
          _this$props$buttonSty = _this$props.buttonStyles,
          buttonStyles = _this$props$buttonSty === void 0 ? {} : _this$props$buttonSty;
      var buttonTextStyles = buttonStyles.buttonTextStyles || {};
      var link = betting ? betting.link : fallbackLink;
      return _react.default.createElement(_react.default.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 22,
          columnNumber: 13
        }
      }, _react.default.createElement(_Basic.Column, {
        isFlex: true,
        center: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23,
          columnNumber: 17
        }
      }, _react.default.createElement(_Touchable.default, {
        onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onPress, link),
        width: [7 / 10, 2 / 5],
        href: link,
        target: "_blank",
        mb: 2,
        rel: "nofollow",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 24,
          columnNumber: 21
        }
      }, _react.default.createElement(_Basic.View, (0, _extends2.default)({
        isFlex: true,
        center: true,
        bg: "switch.on",
        py: 2,
        borderRadius: 2
      }, buttonStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 32,
          columnNumber: 25
        }
      }), _react.default.createElement(_Basic.Text, (0, _extends2.default)({
        color: "font.enclosed",
        bold: true
      }, buttonTextStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 40,
          columnNumber: 29
        }
      }), bettingLinkText))), betting && _react.default.createElement(_Basic.Row, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46,
          columnNumber: 25
        }
      }, _react.default.createElement(_Basic.Text, {
        flexing: true,
        mr: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 47,
          columnNumber: 29
        }
      }, betting.odds), _react.default.createElement(_Basic.Text, {
        mr: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 29
        }
      }, "\u2022"), _react.default.createElement(_Basic.Text, {
        mr: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51,
          columnNumber: 29
        }
      }, betting.stake), _react.default.createElement(_Basic.Text, {
        mr: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 52,
          columnNumber: 29
        }
      }, "\u2022"), _react.default.createElement(_Basic.Text, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53,
          columnNumber: 29
        }
      }, betting.profit))));
    }
  }]);
  return TipModule;
}(_react.default.Component);

TipModule.propTypes = {
  bettingLinkText: _propTypes.default.string,
  betting: _propTypes.default.object,
  buttonStyles: _propTypes.default.object,
  fallbackLink: _propTypes.default.string,
  onPress: _propTypes.default.func
};
var _default = TipModule;
exports.default = _default;